export const getSections = (state) => {
    return state.constructs.sections;
}

export const getDigitalTwinSections = digitalTwinId => state => {
    return getSections(state).filter(section => section.parent[0].id == digitalTwinId);
}

export const getProfileSections = profile => state => {
    if (profile === undefined) return [];
    return getSections(state).filter(section => section.parent[0].id == profile.id);
}